/* Home page: hero gallery, favourites tabs and arrows, add to cart, recently
   viewed, video switcher. Markup: sections/lb-home-*.liquid. */
(function () {
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- hero gallery ---- */
  var hero = $('[data-lb-hero]');
  if (hero) {
    var slides = $$('[data-lb-slide]', hero), dots = $$('[data-lb-dot]', hero), pauseBtn = $('[data-lb-pause]', hero);
    /* No auto-advance: the visitor moves the gallery. Pause/Play controls the film. */
    var cur = 0, paused = reduce;
    var saver = navigator.connection && navigator.connection.saveData;
    var films = $$('[data-lb-film]', hero);
    var wantFilm = !reduce && !saver, ready = false;
    var syncFilms = function () {
      films.forEach(function (v) {
        var on = slides[cur].contains(v);
        if (!on || paused || !wantFilm || !ready) { v.pause(); return; }
        if (!v.getAttribute('src')) v.src = (window.matchMedia('(max-width: 720px)').matches ? v.dataset.srcSm : v.dataset.src);
        var pr = v.play(); if (pr && pr.catch) pr.catch(function () {});
      });
    };
    var show = function (n) {
      cur = (n + slides.length) % slides.length;
      slides.forEach(function (s, i) { s.classList.toggle('is-on', i === cur); s.setAttribute('aria-hidden', i === cur ? 'false' : 'true'); });
      dots.forEach(function (d, i) { d.classList.toggle('is-on', i === cur); });
      var light = slides[cur].dataset.scheme === 'light';
      hero.classList.toggle('is-light-ctl', light); hero.classList.toggle('is-dark-ctl', !light);
      syncFilms();
    };
    var label = function () { if (pauseBtn) pauseBtn.textContent = paused ? 'Play' : 'Pause'; };
    hero.addEventListener('click', function (e) {
      var t = e.target, b;
      if ((b = t.closest('[data-lb-dot]'))) show(+b.dataset.lbDot);
      else if (t.closest('[data-lb-prev]')) show(cur - 1);
      else if (t.closest('[data-lb-next]')) show(cur + 1);
      else if (t.closest('[data-lb-pause]')) { paused = !paused; label(); syncFilms(); }
    });
    show(0); label();
    /* The poster paints first; the film is fetched once the page is idle. */
    if (films.length && wantFilm) {
      var start = function () { ready = true; syncFilms(); };
      if (document.readyState === 'complete') setTimeout(start, 300); else window.addEventListener('load', function () { setTimeout(start, 300); });
    }
    if (pauseBtn && !films.length) pauseBtn.hidden = true;
  }

  /* ---- cart ---- */
  function refreshCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      var n = document.querySelector('.header__cart-count');
      if (n) { n.dataset.n = c.item_count; var num = n.querySelector('.header__cart-count-number'); if (num) num.textContent = c.item_count; }
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: c }));
    }).catch(function () {});
  }

  /* ---- favourites ---- */
  $$('[data-lb-favs]').forEach(function (root) {
    var tracks = $$('[data-lb-trk]', root), tabs = $$('[data-lb-tab]', root);
    function active() { return tracks.filter(function (t) { return !t.hidden; })[0] || tracks[0]; }
    function page(dir) {
      var t = active(); if (!t) return;
      var w = t.clientWidth + 20;
      if (dir > 0 && t.scrollLeft + t.clientWidth >= t.scrollWidth - 4) { t.scrollTo({ left: 0 }); return; }
      t.scrollBy({ left: dir * w });
    }
    root.addEventListener('click', function (e) {
      var t = e.target, b;
      if ((b = t.closest('[data-lb-tab]'))) {
        tabs.forEach(function (x) { x.classList.toggle('is-on', x === b); });
        tracks.forEach(function (x) { x.hidden = x.dataset.lbPanel !== b.dataset.lbTab; });
      } else if (t.closest('[data-lb-fprev]')) page(-1);
      else if (t.closest('[data-lb-fnext]')) page(1);
      else if ((b = t.closest('[data-lb-add]'))) {
        var card = b.closest('[data-vid]');
        b.disabled = true;
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +card.dataset.vid, quantity: 1 }] }) })
          .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
          .then(function () {
            b.textContent = 'Added ✓'; refreshCount();
            setTimeout(function () { b.textContent = 'Add to cart'; b.disabled = false; }, 1400);
          }).catch(function () { b.textContent = 'Try again'; b.disabled = false; });
      }
    });

    /* recently viewed */
    var box = $('[data-lb-recent]', root), row = box && $('[data-lb-recent-row]', box);
    if (row) {
      var list = [];
      try { list = JSON.parse(localStorage.getItem('lb-recent') || '[]'); } catch (e) {}
      if (list.length) {
        var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
        row.innerHTML = list.slice(0, 8).map(function (p) {
          return '<a class="lb-hm-rv" href="' + esc(p.u) + '"><span class="lb-hm-rv__i">' + (p.i ? '<img src="' + esc(p.i) + '" alt="" loading="lazy" width="56" height="56">' : '') + '</span><span class="lb-hm-rv__t">' + esc(p.t) + '<span class="lb-hm-rv__p" style="display:block">' + esc(String(p.p).replace(/<[^>]*>/g, '')) + '</span></span></a>';
        }).join('');
        box.hidden = false;
      }
    }
  });

  /* ---- video switcher ---- */
  $$('[data-lb-yt]').forEach(function (root) {
    var player = $('[data-lb-yt-player]', root), items = $$('[data-lb-yt-it]', root), id = items[0] && items[0].dataset.id;
    function pick(it) {
      id = it.dataset.id;
      items.forEach(function (x) { x.classList.toggle('is-on', x === it); });
      player.innerHTML = '<img src="https://i.ytimg.com/vi/' + id + '/hqdefault.jpg" alt="" data-lb-yt-img><button type="button" class="lb-hm-yt__play" data-lb-yt-play aria-label="Play video"></button>' + (it.dataset.dur ? '<span class="lb-hm-dur">' + it.dataset.dur.replace(/</g, '') + '</span>' : '');
      $('[data-lb-yt-title]', root).textContent = it.dataset.title;
      $('[data-lb-yt-meta]', root).textContent = it.dataset.meta;
    }
    root.addEventListener('click', function (e) {
      var it = e.target.closest('[data-lb-yt-it]');
      if (it) { pick(it); return; }
      if (e.target.closest('[data-lb-yt-play]') && id) {
        player.innerHTML = '<iframe src="https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0" title="Video" allow="autoplay; encrypted-media; picture-in-picture; fullscreen" allowfullscreen></iframe>';
      }
    });
  });
})();
